export default __webpack_public_path__ + "static/media/DASH.0a88c68a.svg";